import { Stack, Text } from '@chakra-ui/react';
import { ColumnDef } from '@tanstack/react-table';
import { datePrettier } from 'utils/date';

function GetColumns(): ColumnDef<SubscriptionUser, string>[] {
  return [
    {
      header: 'Email',
      accessorKey: 'email',
      cell: (info) => info.getValue(),
    },
    {
      header: 'Suma punktów',
      accessorKey: 'loyaltyPoints',
      cell: ({
        row: {
          original: { loyaltyPoints, pendingLoyaltyPoints },
        },
      }) => (
        <Text as="span">
          {loyaltyPoints}
          {pendingLoyaltyPoints > 0 &&
            ` (+${pendingLoyaltyPoints} oczekujących)`}
        </Text>
      ),
    },
    {
      header: 'Numery kart',
      accessorKey: 'cardNumbers',
      cell: ({
        row: {
          original: { cardNumbers },
        },
      }) => (
        <Stack>
          {cardNumbers.map((cardNumber) => (
            <Text as="span" key={cardNumber}>
              {cardNumber}
            </Text>
          ))}
        </Stack>
      ),
    },
    {
      header: 'Data utworzenia',
      accessorKey: 'createdAt',
      cell: (info) => datePrettier(info.getValue()),
    },
    {
      header: 'Akcje',
      accessorKey: 'action',
    },
  ];
}

export default GetColumns;
